import {Link} from "react-router-dom";

import './Steps.css';
import BoltIcon from "../../../assets/icons/bolt.svg";
import ChevronIcon from "../../../assets/icons/chevron-double-down.svg";
import ArrowUpIcon from "../../../assets/icons/arrow-up.svg";
import WindowIcon from "../../../assets/icons/window.svg";
import BulbIcon from "../../../assets/icons/light-bulb.svg";
import FunnelIcon from "../../../assets/icons/funnel.svg";
import MagicRoadmap from "../../../assets/img/image 9.svg";
import MagicSearch from "../../../assets/img/image 11.svg";
import MagicFeedback from "../../../assets/img/image 14.svg";
import MagicProfiles from "../../../assets/img/image 10.svg";
import Magic3rd from "../../../assets/img/image 12.svg";
import MagicForms from "../../../assets/img/image 13.svg";
import MagicSurvey from "../../../assets/img/image 15.svg";
import SdkIcon from "../../../assets/img/sdk.svg";


export default function Steps() {

    return (
        <div>
            <section className='steps'>
                <div id="collect"
                     className='steps-container'>
                    <div className='steps-header'>
                        <div
                            style={{
                                width: '28px',
                                height: '28px',
                                padding: '4px',
                                background: '#3B82F6',
                                borderRadius: 9.70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 12,
                                display: 'inline-flex',
                                marginRight: '16px'
                            }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                position: 'relative'
                            }}>
                                <img src={FunnelIcon} width={'24px'}/>
                            </div>
                        </div>
                        <div style={{
                            height: '36px',
                            paddingLeft: 32,
                            paddingRight: 32,
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 36,
                            overflow: 'hidden',
                            border: '1px #2563EB solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            display: 'inline-flex'
                        }}>
                            <div
                                style={{
                                    color: '#2563EB',
                                    fontSize: 16,
                                    fontWeight: '600',
                                    wordWrap: 'break-word'
                                }}>Collect
                            </div>
                        </div>
                    </div>
                    <div className='steps-content'>
                        <div className='divider-bar' style={{backgroundColor: '#3B82F6'}}/>
                        <div className='steps-box'>
                            <h6 className="section-title">
                                Collect customer feedback with AI
                            </h6>
                            <h6 className="section-subtitle">
                                From third party integrations to AI surveys, forms and direct SDK integrations: Magic
                                Feedback’s mission is to automate the collection of feedback.
                            </h6>
                            <div id="3rd-party"
                                 className="steps-card steps-card-l">
                                <div className="steps-card-content"
                                     style={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                         justifyContent: 'space-between',
                                         height: 'auto'
                                     }}>
                                    <p>
                                        We support all popular <b>third party integrations.</b> We would automatically
                                        connect all your existing customer feedback sources.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                </div>
                                <div className="image-container-l">
                                    <img src={Magic3rd} alt="Magic Roadmap"/>
                                </div>
                            </div>
                            <div className="steps-cards-container">
                                <div
                                    id="magic-survey"
                                    className="steps-card steps-card-m">
                                    <p>
                                        <b>Magic Survey</b> improves the quality of survey responses. Our AI powered
                                        survey understand your respondents answers and asks real-time, open ended
                                        follow-up question.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                        style={{decoration: 'none'}}
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                    <div>
                                        <img src={MagicSurvey} width={'100%'}/>
                                    </div>
                                </div>
                                <div
                                    id="magic-form"
                                    className="steps-card steps-card-m">
                                    <p>
                                        <b>Magic Form</b> collects high quality feedback in your native application in
                                        those crucial moments where quick and informed decisions matter.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                    <div>
                                        <img src={MagicForms} width={'100%'}/>
                                    </div>
                                </div>
                            </div>
                            <div id="magic-sdk"
                                 className="steps-card steps-card-s">
                                <div>
                                    <img src={SdkIcon} width={'100%'} height={'120px'}/>
                                </div>
                                <div>
                                    <p>
                                        <b>Magic SDK</b> collects customer feedback directly from your system’s
                                        conversations, interactions, and much more.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    id="analysis"
                    className='steps-container'>
                    <div className='steps-header'>
                        <div style={{
                            width: '28px',
                            height: '28px',
                            padding: '4px',
                            background: '#22D3EE',
                            borderRadius: 9.70,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 12,
                            display: 'inline-flex',
                            marginRight: '16px'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                position: 'relative'
                            }}>
                                <img src={BulbIcon} width={'24px'}/>
                            </div>
                        </div>
                        <div style={{
                            height: '36px',
                            paddingLeft: 32,
                            paddingRight: 32,
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 36,
                            overflow: 'hidden',
                            border: '1px #0891B2 solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            display: 'inline-flex'
                        }}>
                            <div style={{
                                color: '#0891B2',
                                fontSize: 16,
                                fontWeight: '600',
                                wordWrap: 'break-word'
                            }}>Analyze
                            </div>
                        </div>
                    </div>
                    <div className='steps-content'>
                        <div className='divider-bar' style={{backgroundColor: '#22D3EEFF'}}/>
                        <div className='steps-box'>
                            <h6 className="section-title">
                                Automatically Analyze Customer Feedback
                            </h6>
                            <h6 className="section-subtitle">
                                Uncover deeper customer insights at scale with our cutting-edge AI tool.
                            </h6>
                            <div className="steps-cards-container-l">
                                <div
                                    id="magic-feedback"
                                    className="steps-card steps-card-l">
                                    <div className="steps-card-content">
                                        <p>
                                            <b>Magic Feedback</b> makes it easy to analyze and categorize all your
                                            feedback automatically in real-time using AI.
                                        </p>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                            gap: 12,
                                            marginTop: '20px'
                                        }}>
                                            <div className='card-item'>
                                                <div style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    padding: '4px',
                                                    background: '#0F172A',
                                                    borderRadius: 9.70,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 12,
                                                    display: 'inline-flex',
                                                    marginRight: '16px'
                                                }}>
                                                    <div style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        position: 'relative'
                                                    }}>
                                                        <img src={WindowIcon} width={'24px'}/>
                                                    </div>
                                                </div>
                                                <div style={{
                                                    color: '#64748B',
                                                    fontSize: 14,
                                                    fontWeight: '400',
                                                    wordWrap: 'break-word',
                                                    textAlign: 'start'
                                                }}>Uncover market problems at a glance
                                                </div>
                                            </div>
                                            <div className='card-item'>
                                                <div style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    padding: '4px',
                                                    background: '#0F172A',
                                                    borderRadius: 9.70,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 12,
                                                    display: 'inline-flex',
                                                    marginRight: '16px'
                                                }}>
                                                    <div style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        position: 'relative'
                                                    }}>
                                                        <img src={ArrowUpIcon} width={'24px'}/>
                                                    </div>
                                                </div>
                                                <div style={{
                                                    color: '#64748B',
                                                    fontSize: 14,
                                                    fontWeight: '400',
                                                    wordWrap: 'break-word',
                                                    textAlign: 'start'
                                                }}>See top feature requests and user stories.
                                                </div>
                                            </div>
                                            <div className='card-item'>
                                                <div style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    padding: '4px',
                                                    background: '#0F172A',
                                                    borderRadius: 9.70,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 12,
                                                    display: 'inline-flex',
                                                    marginRight: '16px'
                                                }}>
                                                    <div style={{
                                                        width: '24px',
                                                        height: '24px',
                                                        position: 'relative'
                                                    }}>
                                                        <img src={ChevronIcon} width={'24px'}/>
                                                    </div>
                                                </div>
                                                <div style={{
                                                    color: '#64748B',
                                                    fontSize: 14,
                                                    fontWeight: '400',
                                                    wordWrap: 'break-word',
                                                    textAlign: 'start'
                                                }}>Explore trends and do drill downs.
                                                </div>
                                            </div>
                                        </div>
                                        <a
                                            href="/schedule-demo"
                                            className="steps-card-link"
                                        >
                                            Schedule Demo
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                    fill="#0F172A"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="image-container-l">
                                        <img src={MagicFeedback} alt="Magic Roadmap"/>
                                    </div>
                                </div>
                                <div
                                    id="magic-profiles"
                                    className="steps-card steps-card-l">
                                    <div className="steps-card-content" style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        height: 'auto'
                                    }}>
                                        <p>
                                            <b>Magic Profiles</b> make it easy to recruit participants and find the
                                            perfect interview candidates for any customer research. Understand your
                                            customer’s past behaviours.
                                        </p>
                                        <a
                                            href="/schedule-demo"
                                            className="steps-card-link"
                                        >
                                            Schedule Demo
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                    fill="#0F172A"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="image-container-l">
                                        <img src={MagicProfiles} alt="Magic Roadmap"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    id="action"
                    className='steps-container'>
                    <div className='steps-header'>
                        <div style={{
                            width: '28px',
                            height: '28px',
                            padding: '4px',
                            background: '#4ADE80',
                            borderRadius: 9.70,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 12,
                            display: 'inline-flex',
                            marginRight: '16px'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                position: 'relative'
                            }}>
                                <img src={BoltIcon} width={'24px'}/>
                            </div>
                        </div>
                        <div style={{
                            height: '36px',
                            paddingLeft: 32,
                            paddingRight: 32,
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 36,
                            overflow: 'hidden',
                            border: '1px #4ADE80 solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            display: 'inline-flex'
                        }}>
                            <div style={{
                                color: '#15803D',
                                fontSize: 16,
                                fontWeight: '600',
                                wordWrap: 'break-word'
                            }}>Action
                            </div>
                        </div>
                    </div>
                    <div className='steps-content'>
                        <div className='divider-bar' style={{backgroundColor: '#4ADE80'}}/>
                        <div className='steps-box'>
                            <h6 className="section-title">
                                Build products users love
                            </h6>
                            <h6 className="section-subtitle">
                                Make better product decisions faster with data-driven insights.
                            </h6>
                            <div className="steps-cards-container">
                                <div
                                    id="magic-search"
                                    className="steps-card steps-card-m">
                                    <p>
                                        <b>Magic Search</b> lets you find any feedback anywhere by simply asking for it.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                    <div>
                                        <img src={MagicSearch} width={'100%'}/>
                                    </div>
                                </div>
                                <div
                                    id="magic-roadmap"
                                    className="steps-card steps-card-m">
                                    <p>
                                        <b>Magic Roadmap</b> helps teams collaborate and align on priorities with deep
                                        insights into user stories.
                                    </p>
                                    <a
                                        href="/schedule-demo"
                                        className="steps-card-link"
                                        style={{decoration: 'none'}}
                                    >
                                        Schedule Demo
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M3 10C3 9.58579 3.33579 9.25 3.75 9.25L14.3879 9.25L10.2302 5.29062C9.93159 5.00353 9.92228 4.52875 10.2094 4.23017C10.4965 3.93159 10.9713 3.92228 11.2698 4.20937L16.7698 9.45937C16.9169 9.60078 17 9.79599 17 10C17 10.204 16.9169 10.3992 16.7698 10.5406L11.2698 15.7906C10.9713 16.0777 10.4965 16.0684 10.2094 15.7698C9.92228 15.4713 9.93159 14.9965 10.2302 14.7094L14.3879 10.75L3.75 10.75C3.33579 10.75 3 10.4142 3 10Z"
                                                fill="#0F172A"
                                            />
                                        </svg>
                                    </a>
                                    <div>
                                        <img src={MagicRoadmap} width={'100%'}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
